import './tag.scss';

import './tag.scss';
import Icon, { IconProps, IconType } from '../icon/Icon';

import { FilterType } from '../../lib/system-selector/interfaces';
import classNames from 'classnames';

export enum TagState {
  DEFAULT = 'default',
  HOVERED = 'hovered',
  ACTIVE = 'active',
}

export enum TagVariant {
  BUTTON = 'button',
  LINK = 'link',
  SPAN = 'span',
}

export interface TagProps {
  id: string;
  label: string;
  state?: TagState;
  icon?: IconProps;
  isFacet?: boolean;
  variant?: string;
  isLoading?: boolean;
  filterType?: FilterType;
  includedInTopFilter?: boolean;
  onClick?: (label: string) => void;
}

const Tag = ({
  id,
  label,
  state = TagState.DEFAULT,
  icon,
  isFacet = false,
  variant = TagVariant.BUTTON,
  isLoading = false,
  includedInTopFilter,
  onClick,
}: TagProps) => {
  if (variant === TagVariant.SPAN) {
    return (
      <span
        className={classNames({
          'a-tag u-label-tiny': true,
          hover: state === TagState.HOVERED,
          active: state === TagState.ACTIVE,
        })}
      >
        {label}
      </span>
    );
  }

  return (
    <button
      id={id ? `tag-${id}` : undefined}
      type="button"
      className={classNames({
        'a-tag u-label-tiny': true,
        hover: state === TagState.HOVERED,
        active: state === TagState.ACTIVE,
        'a-tag--partial-skeleton': isLoading,
      })}
      onClick={onClick ? () => onClick(label) : undefined}
    >
      {icon && <Icon {...icon} />}

      <span className="u-text-ellipsis a-tag__label">{label}</span>

      {isFacet && (
        <span className="a-tag__remove">
          <Icon iconType={IconType.Close} className="u-icon-micro" />
        </span>
      )}
    </button>
  );
};

export default Tag;
